import React from 'react';
import ReportPdfHeader from '../../components/reports/shared/report-pdf-header';
import CandidateReportSummary from '../../components/reports/candidate/candidate-report-summary';
import CandidateProfileAssessments from '../../components/reports/candidate-profile/candidate-profile-assessments';
import CandidateProfileHeader from '../../components/reports/shared/report-header';
import CandidateInterviewSummary from '../../components/reports/candidate-profile/candidate-interview-summary';
import CandidateConfidentialPage from '../../components/reports/candidate/candidate-confidential-page';
import CandidateExecutiveSummary from '../../components/reports/candidate/candidate-executive-summary';
import CandidateRecruiterProfile from '../../components/reports/candidate/candidate-recruiter-profile';
import { REPORT_TYPE } from '../../utils/constants';

function CandidateProfile({ candidate, reportType = REPORT_TYPE.coaching }) {
  return (
    <>
      <div className="print-page">
        <CandidateConfidentialPage candidate={candidate} competencies={true} reportType={reportType} />
      </div>
      <div className="print-page print-heading">
        <ReportPdfHeader />
        <CandidateProfileHeader candidate={candidate} />
        <CandidateReportSummary
          candidate={candidate}
          withAssessmentText={true}
          withRecommendationSummary={reportType === REPORT_TYPE.coaching}
          reportType={reportType}
        />
        {reportType === REPORT_TYPE.staffing && <CandidateProfileAssessments candidate={candidate} />}
      </div>
      {reportType === REPORT_TYPE.staffing ? (
        <>
          <div className="print-page">
            <CandidateProfileHeader candidate={candidate} remoteStaffing={true} />
            <CandidateReportSummary
              candidate={candidate}
              withAssessmentText={true}
              withRecommendationSummary={reportType === REPORT_TYPE.coaching}
              remoteStaffing={true}
              reportType={reportType}
            />
            <CandidateProfileAssessments candidate={candidate} remoteStaffing={true} />
          </div>
          <div className="print-page">
            <CandidateRecruiterProfile candidate={candidate} />
          </div>
        </>
      ) : (
        <div className="print-page">
          <CandidateProfileAssessments candidate={candidate} />
        </div>
      )}
      {candidate.interviewCompetencies?.comments && (
        <div className="print-page">
          <CandidateExecutiveSummary comments={candidate.interviewCompetencies.comments} />
        </div>
      )}
      {candidate.interviewCompetencies?.scores && (
        <div className="print-page">
          <CandidateInterviewSummary candidate={candidate} />
        </div>
      )}
    </>
  );
}

export default CandidateProfile;
